import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const ErrorPage = React.lazy(() => import("@mediaspace/features/error-page"));

export const render = getDsLayoutComponentRenderer(ErrorPage);
